import { TechnologiesSection, HeroSection, AboutSection, ProjectSection, ContactSection } from '@/sections';

export default function Home()
{
    return (
        <>
            <HeroSection></HeroSection>
            <TechnologiesSection></TechnologiesSection>
            <ProjectSection></ProjectSection>
            <AboutSection></AboutSection>
            <ContactSection></ContactSection>
        </>
    );
}